import React from 'react';
import { Page, BText } from '../../../components';

export const MySettingNotification = () => {
  return (
    <Page title={'Notification'}>
      <BText>Content</BText>
    </Page>
  );
};
